export default {
    localizations: []
}